import { SaleTypes } from 'constants/saleTypes';
import { ISaleInput } from 'interfaces/inputs/ISaleInput';
import ISale, { SaleTenureTypeEnum } from 'interfaces/ISale';

export const isCondoSale = (sale: ISale | ISaleInput) =>
  sale.type?.name === SaleTypes.condo;

export const isLongLeaseHolder = (sale: ISale | ISaleInput) =>
  sale.tenureType === SaleTenureTypeEnum.LONG_LEASEHOLD;
